module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_c('div', {
    staticClass: "box box-primary"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', [_vm._v("Select Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.branches,
      "label": "name",
      "name": "branch",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', [_vm._v("Select Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.date),
      expression: "form.date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "date"
    },
    domProps: {
      "value": (_vm.form.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "form-control btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" GET RECORDS")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 bg-green"
  }, [_c('center', [_c('strong', [_vm._v("CASH BOOK")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', [(_vm.cashbookcashRecord.opening_balance >= 0) ? _c('span', [_vm._v("Opening Balance")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.cashbookcashRecord.opening_balance >= 0) ? _c('span', [_vm._v(_vm._s(parseFloat(_vm.cashbookcashRecord.opening_balance + 0).toFixed(2)))]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.cashbookcashRecord.opening_balance < 0) ? _c('span', [_vm._v("Opening Balance")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.cashbookcashRecord.opening_balance < 0) ? _c('span', [_vm._v(_vm._s(parseFloat(_vm.cashbookcashRecord.opening_balance + 0).toFixed(2)))]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.cashbookcashRecord.vouchers), function(voucher, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [(voucher.type === 'cr') ? _c('span', [_vm._v(_vm._s(voucher.ledger.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(voucher.type === 'cr') ? _c('span', [_vm._v(_vm._s(parseFloat(voucher.total_amt + 0).toFixed(2)))]) : _vm._e()]), _vm._v(" "), _c('td', [(voucher.type === 'dr') ? _c('span', [_vm._v(_vm._s(voucher.ledger.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(voucher.type === 'dr') ? _c('span', [_vm._v(_vm._s(parseFloat(voucher.total_amt + 0).toFixed(2)))]) : _vm._e()])])
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(_vm.cashbookcashRecord.dr_total + 0).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(_vm.cashbookcashRecord.cr_total + 0).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Closing Balance " + _vm._s(parseFloat(_vm.cashbookcashRecord.closing_balance + 0).toFixed(2)) + " (" + _vm._s(_vm.cashbookcashRecord.closing_balance_type) + ")")])])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('td', [(_vm.cashbookbankRecord.opening_balance >= 0) ? _c('span', [_vm._v("Opening Balance")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.cashbookbankRecord.opening_balance >= 0) ? _c('span', [_vm._v(_vm._s(parseFloat(_vm.cashbookbankRecord.opening_balance + 0).toFixed(2)))]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.cashbookbankRecord.opening_balance < 0) ? _c('span', [_vm._v("Opening Balance")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.cashbookbankRecord.opening_balance < 0) ? _c('span', [_vm._v(_vm._s(parseFloat(_vm.cashbookbankRecord.opening_balance + 0).toFixed(2)))]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.cashbookbankRecord.vouchers), function(voucher, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [(voucher.type === 'cr') ? _c('span', [_vm._v(_vm._s(voucher.ledger.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(voucher.type === 'cr') ? _c('span', [_vm._v(_vm._s(parseFloat(voucher.total_amt + 0).toFixed(2)))]) : _vm._e()]), _vm._v(" "), _c('td', [(voucher.type === 'dr') ? _c('span', [_vm._v(_vm._s(voucher.ledger.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(voucher.type === 'dr') ? _c('span', [_vm._v(_vm._s(parseFloat(voucher.total_amt + 0).toFixed(2)))]) : _vm._e()])])
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(_vm.cashbookbankRecord.dr_total + 0).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(_vm.cashbookbankRecord.cr_total + 0).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Closing Balance " + _vm._s(parseFloat(_vm.cashbookbankRecord.closing_balance + 0).toFixed(2)) + " (" + _vm._s(_vm.cashbookbankRecord.closing_balance_type) + ")")])])])], 2)])]), _vm._v(" "), _c('hr')])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Cash Records")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Debit")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2",
      "Class": "text-center"
    }
  }, [_vm._v("Credit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('td', [_c('strong', [_vm._v("Particulars")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Dr")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Particulars")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Cr")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Bank Records")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Debit")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2",
      "Class": "text-center"
    }
  }, [_vm._v("Credit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('td', [_c('strong', [_vm._v("Particulars")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Dr")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Particulars")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Cr")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69d57aac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/accounting/CashBook.vue
// module id = 895
// module chunks = 0